import {
  TEAM_MENTION_REGEX_STR,
  USER_MENTION_PREFIX,
  USER_MENTION_REGEX_STR,
} from "@mapmycustomers/shared/util/consts/mentions";
import { PHONE_REGEX_STR } from "@mapmycustomers/shared/util/phone/parsePhoneNumber";
import { splitStringByRegExp } from "@mapmycustomers/shared/util/stringUtils";

const emailRegExStr = `[^${USER_MENTION_PREFIX}\\s]+@\\S+\\.\\S+`;
const urlRegExStr = `(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})`;
const regex = new RegExp(
  `(?<url>${urlRegExStr})|(?<email>${emailRegExStr})|${PHONE_REGEX_STR}|${USER_MENTION_REGEX_STR}|${TEAM_MENTION_REGEX_STR}`,
  "g"
);

type URL = {
  type: "url";
  url: string;
};

type Email = {
  email: string;
  type: "email";
};

type Phone = {
  phone: string;
  type: "phone";
};

type User = {
  type: "user";
  username: string;
};

type Team = {
  teamId: number;
  type: "team";
};

type Text = {
  type: "text";
  value: string;
};

export type Token = Email | Phone | Team | Text | URL | User;

export const tokenize = (text: string): Token[] =>
  splitStringByRegExp(text, regex).map((item) => {
    if (item.type === "text") {
      return { type: "text", value: item.text };
    }
    const groups = item.match.groups!;
    if (groups.url) {
      return { type: "url", url: groups.url };
    } else if (groups.email) {
      return { email: groups.email, type: "email" };
    } else if (groups.phone) {
      return { phone: groups.phone, type: "phone" };
    } else if (groups.username) {
      return { type: "user", username: groups.username };
    } else if (groups.team) {
      return { teamId: parseInt(groups.team, 10), type: "team" };
    }
    return { type: "text", value: item.match[0] };
  });
